import React, { FC, useEffect, useState } from 'react';
import type { Order } from '@Types/cart/Order';
import Spinner from 'components/commercetools-ui/spinner';
import ChevronLeftIcon from 'components/icons/chevron-left';
import Button from 'components/revelo-ui/content/button';
import Markdown from 'components/revelo-ui/content/markdown';
import { useFormat } from 'helpers/hooks/useFormat';
import { Reference } from 'helpers/reference';
import { useCart } from 'frontastic';
import OrderItem from './order/orderItem';

export interface OrderHistoryProps {
  orders?: Order[];
  onCloseContent?: () => void;
  noOrdersText?: string;
  noOrdersBtnEnable?: boolean;
  noOrdersBtnLink?: Reference;
  noOrdersBtnText?: string;
  onSelectOrder?: (order: Order) => void;
}

const OrdersHistory: FC<OrderHistoryProps> = ({
  orders,
  noOrdersText,
  noOrdersBtnEnable,
  noOrdersBtnLink,
  noOrdersBtnText,
  onCloseContent,
  onSelectOrder,
}) => {
  const [accountOrdersState, setAccountOrders] = useState<Order[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });
  const { orderHistory } = useCart();

  useEffect(() => {
    if (orderHistory) {
      orderHistory().then((data) => {
        setAccountOrders(data);
        setLoading(false);
      });
    } else {
      setAccountOrders(orders);
      setLoading(false);
    }
  }, [orders, orderHistory]);

  return (
    <div>
      <div className="">
        <h3 className="mb-8 flex items-center gap-2 font-headline text-xl text-neutral-950">
          <button onClick={onCloseContent} className="lg:hidden">
            <ChevronLeftIcon className="size-6" />
          </button>
          {formatAccountMessage({ id: 'my.orders.history', defaultMessage: 'My order history' })}
        </h3>
        {loading ? (
          <div className="flex items-stretch justify-center px-12 py-10">
            <Spinner />
          </div>
        ) : accountOrdersState && accountOrdersState.length ? (
          <div className="grid grid-cols-1 gap-4 text-sm">
            {accountOrdersState.map((order: Order) => (
              <OrderItem key={order.orderId} order={order} onClick={onSelectOrder} link="#orderDetail" />
            ))}
          </div>
        ) : (
          <>
            <div className="mt-8">
              <Markdown text={noOrdersText} />
            </div>
            {noOrdersBtnEnable && (
              <div className="mt-8">
                <Button style="primary" reference={noOrdersBtnLink}>
                  {noOrdersBtnText}
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default OrdersHistory;
